var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.52 100 100 77.48 100 50C100 22.48 77.48 0 50 0C22.48 0 0 22.52 0 50C0 77.52 22.52 100 50 100Z",
    fill: "url(#paint0_linear_4756_21472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4783 60.7998L78.6383 52.6398C79.3983 52.1998 79.8383 51.3998 79.8383 50.5198V34.1998C79.8383 33.3198 79.3583 32.5198 78.6383 32.0798L64.4783 23.9198C63.7183 23.4798 62.7983 23.4798 62.0383 23.9198L47.8783 32.0798C47.1183 32.5198 46.6783 33.3198 46.6783 34.1998V63.3998L36.7583 69.1198L26.8383 63.3998V51.9598L36.7583 46.2398L43.3183 49.9998V42.3198L37.9983 39.2398C37.6383 39.0398 37.1983 38.9198 36.7983 38.9198C36.3583 38.9198 35.9583 39.0398 35.5983 39.2398L21.4383 47.3998C20.6783 47.8398 20.2383 48.6398 20.2383 49.5198V65.8398C20.2383 66.7198 20.7183 67.5198 21.4383 67.9598L35.5983 76.1198C36.3583 76.5598 37.2783 76.5598 38.0383 76.1198L52.1983 67.9598C52.9583 67.5198 53.3983 66.7198 53.3983 65.8398V36.6398L53.5583 36.5198L63.3183 30.8798L73.2383 36.5998V48.0398L63.3183 53.7598L56.7983 49.9998V57.6798L62.1183 60.7598C62.8783 61.1998 63.7983 61.1998 64.5583 60.7598L64.4783 60.7998Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4756_21472",
    x1: -18.2893,
    y1: 8.12046,
    x2: 84.8307,
    y2: 71.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A229C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol);
export default __webpack_public_path__ + "static/media/POL.c9177946c91e829873338fd66785b099.svg";
export { ForwardRef as ReactComponent };